export default __webpack_public_path__ + "static/media/EM1460.34I-37467_-22069_0.0eeaef8e.jpg";